import {VerbrauchsanalyseForm} from "../../verbrauchsanalyse/verbrauchsanalyse.form";

/**
 * Configuratuion for the input of the first chapter in the moderat advisor.
 * @inheritDoc
 */
export class VerbrauchsanalyseModeratForm extends VerbrauchsanalyseForm {
  /**
   * @inheritDoc
   */
  modus: string = 'hec';

  /**
   * groups for the 'basisinformationen' section when the user is interested in district heating
   * (interesse === 'fernwaerme'): PLZ and address are asked first (followed by the district
   * heating result page, see moderat-routing.module.ts), the remaining questions follow after.
   * @protected
   */
  protected groupsFernwaerme: any = {
    'basisinformationen/1': ['postleitzahl', 'ort'],
    'basisinformationen/2': ['adresse', 'adresse_postalcode', 'adresse_strasse', 'adresse_hausnummer'],
    'basisinformationen/3': ['nutzungstyp'],
    'basisinformationen/4': ['gebaeudetyp'],
    'basisinformationen/5': ['gebaeude_denkmalschutz'],
    'basisinformationen/6': ['heizungstyp'],
    'basisinformationen/7': ['energietraeger_name'],
    'basisinformationen/8': ['gebaeudebaujahr'],
    'basisinformationen/9': ['bewohneranzahl'],
  };

  /**
   * default groups for the 'basisinformationen' section (interesse !== 'fernwaerme'), used
   * regardless of whether the address step is additionally enabled via portal config.
   * @protected
   */
  protected groupsDefault: any = {
    'basisinformationen/1': ['nutzungstyp'],
    'basisinformationen/2': ['gebaeudetyp'],
    'basisinformationen/3': ['gebaeude_denkmalschutz'],
    'basisinformationen/4': ['heizungstyp'],
    'basisinformationen/5': ['energietraeger_name'],
    'basisinformationen/6': ['gebaeudebaujahr'],
    'basisinformationen/7': ['postleitzahl', 'ort'],
    'basisinformationen/8': ['adresse', 'adresse_postalcode', 'adresse_strasse', 'adresse_hausnummer'],
    'basisinformationen/9': ['bewohneranzahl'],
  };

  /**
   * groups that don't depend on anfrage.interesse
   * @protected
   */
  protected staticGroups: any = {
    'heizsystem/1': ['gebaeude_flaeche'],
    'heizsystem/2': ['anzahl_wohneinheiten'],
    'heizsystem/3': ['keller_status'],
    'heizsystem/4': ['warmwasser_bereitungsart'],
    'heizsystem/5': ['warmwasser_messung'],
    'heizsystem/6': ['zusatzheizung_vorhanden'],
    'heizsystem/7': ['zusatzheizung_energietraeger'],
    'heizsystem/8': ['solarthermie_art'],

    'verbrauchsdaten': ['abrechnungszeitraum', 'energietraeger_verbrauch', 'energietraeger_kosten', 'warmwasser_verbrauch_bekannt', 'warmwasser_verbrauch', 'warmwasser_temperatur', 'zusatzheizung_verbrauch_bekannt', 'zusatzheizung_verbrauch', 'zusatzheizung_kosten'],

    // wpcheck
    'wpcbasisinformationen/1': ['bewohneranzahl'],
    'wpcbasisinformationen/2': ['anzahl_wohneinheiten'],
    'wpcheizsystem/1': ['warmwasser_messung'],
    'wpcheizsystem/2': ['zusatzheizung_vorhanden'],
    'wpcheizsystem/3': ['zusatzheizung_energietraeger'],
    'wpcheizsystem/4': ['solarthermie_art']
  };

  /**
   * @inheritDoc
   * @protected
   */
  protected groups: any = {...this.groupsDefault, ...this.staticGroups};

  /**
   * (Re)selects the 'basisinformationen' groups mapping based on anfrage.interesse. Must be
   * called once anfrage is available on this form (before the first getForm()/getFieldsFromGroup()
   * call for a 'basisinformationen/N' step), since 'groups' cannot be a getter here: the base
   * class VerbrauchsanalyseForm already declares 'groups' as an assignable field, and mixing that
   * with a getter override would throw at runtime ("has only a getter") the moment its field
   * initializer runs.
   */
  updateGroups(): void {
    this.groups = {
      ...(this.anfrage?.interesse === 'fernwaerme' ? this.groupsFernwaerme : this.groupsDefault),
      ...this.staticGroups
    };
  }

  /**
   * returns the default (non-fernwaerme) group name that contains the given field id. Used to
   * resolve help texts, which are translated per default step number (e.g. 'moderat.help.basisinformationen.7'
   * for PLZ) - that numbering doesn't shift for interesse === 'fernwaerme', only the route it's shown on does.
   */
  getDefaultGroupName(fieldId: string): string {
    return Object.keys(this.groupsDefault).find(name => this.groupsDefault[name].indexOf(fieldId) !== -1) ?? null;
  }

}
